<main class="nom-page">
  <section class="nom-shell">
    <header class="nom-header">
      <img src="assets/img/Logotipo_v2.png" alt="Médica Móvil" class="nom-logo">
      <div>
        <p class="nom-eyebrow">{{ officialTitle }}</p>
        <h1>NOM 035</h1>
      </div>
    </header>

    <section class="nom-card" *ngIf="step === 'loading'">
      <div class="loading-state">
        <div class="loading-spinner"></div>
        <h2>Cargando cuestionario...</h2>
        <p>Estamos preparando las preguntas oficiales para iniciar la evaluación.</p>
      </div>
    </section>

    <section class="nom-card" *ngIf="step === 'survey'">
      <div class="nom-intro">
        <h2>{{ questionnaireTitle }}</h2>
        <p>{{ instruction }}</p>
      </div>

      <p class="submit-error" *ngIf="guideError">{{ guideError }}</p>
      <p class="submit-error" *ngIf="errorMessage">{{ errorMessage }}</p>

      <form [formGroup]="surveyForm" (ngSubmit)="submitSurvey()" novalidate>
        <div formGroupName="answers" class="survey-layout">
          <section class="section-table gate-table" *ngIf="firstQuestion">
            <div class="section-table__header">
              <div>
                <h4>{{ sections[0]?.officialLabel || sections[0]?.title || 'Sección I' }}</h4>
              </div>
              <span>Respuesta</span>
            </div>

            <div class="question-table">
              <div class="question-row question-row--header">
                <span>Pregunta</span>
                <span>Sí</span>
                <span>No</span>
              </div>

              <div class="question-row">
                <div class="question-row__text">
                  <p><strong>{{ firstQuestion.id }}</strong> {{ firstQuestion.text }}</p>
                  <small *ngIf="submittedSurvey && answersGroup.get(getAnswerControlName(firstQuestion.id))?.invalid">
                    Selecciona una respuesta.
                  </small>
                </div>

                <mat-radio-group [formControlName]="getAnswerControlName(firstQuestion.id)" class="row-options" (change)="onFirstAnswerChange($event.value)">
                  <mat-radio-button [value]="true" aria-label="Sí">
                    <span class="row-option-label">Sí</span>
                  </mat-radio-button>
                  <mat-radio-button [value]="false" aria-label="No">
                    <span class="row-option-label">No</span>
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          </section>

          <section class="follow-up" *ngIf="shouldShowFollowUpSections">
            <section class="section-table" *ngFor="let section of followUpSections">
              <div class="section-table__header">
                <div>
                  <h4>{{ section.officialLabel || section.title }}</h4>
                  <p *ngIf="section.description">{{ section.description }}</p>
                </div>
                <span>Respuesta</span>
              </div>

              <div class="question-table">
                <div class="question-row question-row--header">
                  <span>{{ section.questions.length === 1 ? 'Pregunta' : 'Preguntas' }}</span>
                  <span>Sí</span>
                  <span>No</span>
                </div>

                <div class="question-row" *ngFor="let question of section.questions">
                  <div class="question-row__text">
                    <p><strong>{{ question.id }}</strong> {{ question.text }}</p>
                    <small *ngIf="submittedSurvey && answersGroup.get(getAnswerControlName(question.id))?.invalid">
                      Selecciona una respuesta.
                    </small>
                  </div>

                  <mat-radio-group [formControlName]="getAnswerControlName(question.id)" class="row-options" (change)="onFollowUpAnswerChange()">
                    <mat-radio-button [value]="true" aria-label="Sí">
                      <span class="row-option-label">Sí</span>
                    </mat-radio-button>
                    <mat-radio-button [value]="false" aria-label="No">
                      <span class="row-option-label">No</span>
                    </mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>
            </section>
          </section>
        </div>

        <p class="submit-error submit-error--inline" *ngIf="errorMessage">{{ errorMessage }}</p>

        <div class="action-row">
          <span class="answered-count" *ngIf="expectedAnswerCount > 0">
            {{ answeredCount }} de {{ expectedAnswerCount }} respuesta(s)
          </span>
          <button
            class="primary-action native-primary-action"
            type="submit"
            [disabled]="isSubmitting || !canContinueSurvey"
          >
            {{ isSubmitting ? 'Evaluando...' : 'Continuar' }}
          </button>
        </div>
      </form>
    </section>

    <section class="nom-card" *ngIf="step === 'contact'">
      <div class="nom-intro">
        <p class="nom-eyebrow">Seguimiento requerido</p>
        <h2>Déjanos tus datos de contacto</h2>
        <p>
          Con base en tus respuestas se requiere revisión del equipo correspondiente.
          Estos datos permiten asociar tu solicitud y dar seguimiento.
        </p>
      </div>

      <form [formGroup]="surveyForm" (ngSubmit)="submitContact()" novalidate class="contact-form">
        <p class="submit-error" *ngIf="errorMessage">{{ errorMessage }}</p>

        <div class="contact-grid">
          <div class="contact-field">
            <label for="nom-contact-first-name">Nombre(s)</label>
            <mat-form-field appearance="outline">
              <input
                id="nom-contact-first-name"
                matInput
                formControlName="first_name"
                autocomplete="given-name"
                placeholder="Ej. Maria Fernanda"
              >
            </mat-form-field>
            <p class="contact-error" *ngIf="submittedContact && surveyForm.get('first_name').hasError('required')">
              El nombre es obligatorio.
            </p>
            <p class="contact-error" *ngIf="submittedContact && surveyForm.get('first_name').hasError('minlength')">
              Escribe al menos 2 caracteres.
            </p>
          </div>

          <div class="contact-field">
            <label for="nom-contact-last-name">Apellidos</label>
            <mat-form-field appearance="outline">
              <input
                id="nom-contact-last-name"
                matInput
                formControlName="last_name"
                autocomplete="family-name"
                placeholder="Ej. Lopez Garcia"
              >
            </mat-form-field>
            <p class="contact-error" *ngIf="submittedContact && surveyForm.get('last_name').hasError('required')">
              Los apellidos son obligatorios.
            </p>
            <p class="contact-error" *ngIf="submittedContact && surveyForm.get('last_name').hasError('minlength')">
              Escribe al menos 2 caracteres.
            </p>
          </div>
        </div>

        <div class="contact-field">
          <label for="nom-contact-email">Correo electrónico</label>
          <mat-form-field appearance="outline">
            <input
              id="nom-contact-email"
              matInput
              formControlName="email"
              autocomplete="email"
              placeholder="correo@ejemplo.com"
            >
          </mat-form-field>
          <p class="contact-error" *ngIf="submittedContact && surveyForm.get('email').hasError('required')">
            El correo es obligatorio.
          </p>
          <p class="contact-error" *ngIf="submittedContact && surveyForm.get('email').hasError('email')">
            Ingresa un correo válido.
          </p>
        </div>

        <div class="contact-field">
          <label for="nom-contact-phone">Teléfono de contacto</label>
          <mat-form-field appearance="outline">
            <input
              id="nom-contact-phone"
              matInput
              formControlName="phone"
              type="tel"
              inputmode="numeric"
              autocomplete="tel"
              maxlength="15"
              placeholder="Ej. 5512345678"
              (input)="onlyPhoneNumbers($event)"
            >
          </mat-form-field>
          <p class="contact-hint" *ngIf="!submittedContact || !surveyForm.get('phone').invalid">
            Solo números, mínimo 10 dígitos.
          </p>
          <p class="contact-error" *ngIf="submittedContact && surveyForm.get('phone').hasError('required')">
            El teléfono es obligatorio.
          </p>
          <p class="contact-error" *ngIf="submittedContact && surveyForm.get('phone').hasError('pattern')">
            Ingresa un teléfono válido.
          </p>
        </div>

        <p class="contact-required-note">Todos los campos son requeridos.</p>

        <div class="action-row">
          <button mat-button type="button" (click)="step = 'survey'" [disabled]="isSubmitting">Regresar</button>
          <button mat-flat-button color="primary" class="primary-action" type="submit" [disabled]="isSubmitting">
            {{ isSubmitting ? 'Enviando...' : 'Enviar respuestas' }}
          </button>
        </div>
      </form>
    </section>

    <section class="nom-card result-card" *ngIf="step === 'done'">
      <div class="result-icon" [class.attention]="requiresAttention">
        <mat-icon>{{ requiresAttention ? 'check_circle' : 'favorite' }}</mat-icon>
      </div>

      <h2 *ngIf="requiresAttention">Tu solicitud fue registrada y será revisada.</h2>
      <h2 *ngIf="!requiresAttention">Gracias por responder</h2>

      <p>{{ resultMessage }}</p>
      <p class="case-id" *ngIf="caseId">Folio: {{ caseId }}</p>
      <p class="close-page-note">Ya puedes cerrar esta pestaña o página.</p>
    </section>
  </section>
</main>
